import { FormInstance } from 'antd'
import React from 'react'
import FormulaAddFunction from '../FormulaAddFunction'
import { useFunctions } from '../../../../pages/settings/company/keyFigures/formulas/functions'

interface FormulaAddFunctionFieldProps {
  form: FormInstance
  formulaError: any
  cursor: { select: (start: number, end?: number) => void; selectionStart: any; selectionEnd: any } | null
}

const FormulaAddFunctionField: React.FC<FormulaAddFunctionFieldProps> = ({ form, formulaError, cursor }) => {
  return (
    <FormulaAddFunction
      form={form}
      requestError={formulaError}
      cursor={cursor}
      functions={Object.values(useFunctions())
        .map(fn => {
          const args = (fn.arguments ?? []).map((arg: any) => arg.label)
          return {
            name: fn.name,
            source: `${fn.name}(${args.join(', ')})`
          }
        })
        .sort((a, b) => a.name.localeCompare(b.name))}
    />
  )
}

export default FormulaAddFunctionField
